import {
    DISTRCT_LIST_PARTNER_SUCCESS,
    DISTRCT_LIST_PARTNER_FAILED,
    RESET_DISTRCT_LIST_PARTNER,
    LOADING_DISTRCT_LIST_PARTNER,
    NETWORK_ERROR_DISTRCT_LIST_PARTNER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetdistrictListPartner = () => {
    return { type: RESET_DISTRCT_LIST_PARTNER };
};

const districtListPartner = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DISTRCT_LIST_PARTNER });
    await partnerServices
        .post("districtListPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch({ type: DISTRCT_LIST_PARTNER_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: DISTRCT_LIST_PARTNER_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DISTRCT_LIST_PARTNER,
                payload: err
            });
        });
};

export { resetdistrictListPartner, districtListPartner };
